import {createReducer} from '@reduxjs/toolkit'
import {AnyAction} from 'redux'
import {changeEventAction} from '../actions/event'
import {GET_POLICIES_OLD, TOGGLE_AGREE_POLICIES_OLD, getPolicies, toggleAgreePolicies} from '../actions/policies'
import {SEND_RSVP_OLD, sendRsvp} from '../actions/rsvp'
import {PoliciesState} from '../types/state'

const defaultState: PoliciesState = {
  agreed: false,
  showAlert: false,
  policies: [],
}

export const policies = createReducer(defaultState, builder => {
  builder
    .addCase(changeEventAction, () => {
      return defaultState
    })
    .addCase(TOGGLE_AGREE_POLICIES_OLD, state => {
      state.agreed = !state.agreed
    })
    .addCase(toggleAgreePolicies, state => {
      state.agreed = !state.agreed
    })
    .addCase(GET_POLICIES_OLD.REQUEST, (state, action: AnyAction) => {
      state.showAlert = action.args[1].showAlert
      state.agreed = false
    })
    .addCase(getPolicies.pending, (state, action) => {
      state.showAlert = action.meta.arg.showAlert
      state.agreed = false
    })
    .addCase(GET_POLICIES_OLD.SUCCESS, (state, action: AnyAction) => {
      return {
        ...state,
        ...action.payload,
        agreed: false,
        showAlert: action.args[1].showAlert,
      }
    })
    .addCase(getPolicies.fulfilled, (state, action) => {
      const showAlert = action.meta.arg.showAlert

      return {
        ...state,
        ...action.payload,
        agreed: false,
        showAlert,
      }
    })
    .addCase(SEND_RSVP_OLD.FAILURE, state => {
      state.agreed = false
    })
    .addCase(sendRsvp.rejected, state => {
      state.agreed = false
    })
})
